import { useRef, useState, useEffect, RefObject } from "react";
import { EditorView, basicSetup } from "codemirror";
import { vim } from "@replit/codemirror-vim";
import { Extension } from "@codemirror/state";

/**
 * CodeMirror does not properly provide th Extension type, so using any[] for now.
 */
export default function useCodeMirror(extensions: Extension[]): {
  ref: RefObject<HTMLDivElement | null>;
  view: EditorView | undefined;
} {
  const ref = useRef<HTMLDivElement | null>(null);
  const [view, setView] = useState<EditorView | undefined>();

  useEffect(() => {
    if (!ref.current) return;

    const view = new EditorView({
      extensions: [basicSetup, vim(), ...extensions],
      parent: ref.current!,
    });

    setView(view);

    /**
     * Make sure to destroy the codemirror instance
     * when our components are unmounted.
     */
    return () => {
      view.destroy();
      setView(undefined);
    };
    /**
     * We only want to run this effect once when the component mounts.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ref, view };
}
